import { BellNotification } from 'iconoir-react';
import moment from 'moment';
import { FunctionComponent, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Tooltip } from '@savgroup-front-common/core/atoms/Tooltip';
import {
  safeFormattedIntlString,
  SafeFormattedMessageWithoutSpread,
} from '@savgroup-front-common/core/formatters';
import { AppScheduledMaintenance } from '@savgroup-front-common/types';

import messages from './messages';
import { $ToastLink, $ToastTime } from './NewScheduledMaintenance.styles';

interface NewScheduledMaintenanceProps {
  scheduledMaintenance: AppScheduledMaintenance;
}

const NewScheduledMaintenance: FunctionComponent<
  NewScheduledMaintenanceProps
> = ({ scheduledMaintenance }) => {
  const { formatDate } = useIntl();

  const duration = useMemo(
    () =>
      moment
        .duration(
          moment(scheduledMaintenance.scheduledFor).diff(
            moment(scheduledMaintenance.scheduledUntil),
          ),
        )
        .humanize(),
    [scheduledMaintenance.scheduledFor, scheduledMaintenance.scheduledUntil],
  );

  return (
    <>
      {scheduledMaintenance.incidentUpdates[0].body}

      <$ToastTime>
        <SafeFormattedMessageWithoutSpread
          message={messages.scheduleTime}
          values={{
            duration,
            time: formatDate(scheduledMaintenance.scheduledFor, {
              day: 'numeric',
              month: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            }),
          }}
        />

        <Tooltip content={safeFormattedIntlString(messages.seemore)}>
          <$ToastLink
            href={scheduledMaintenance.shortlink}
            isExternal
            target="_blank"
          >
            <BellNotification />
          </$ToastLink>
        </Tooltip>
      </$ToastTime>
    </>
  );
};

export default NewScheduledMaintenance;
